import { Container, Position } from "./PhotoStyles";

import ButtonGroup from "../../../components/ui/ButtonGroup";
import ProgressBar from "../../../components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import TitleStyles from "../../../components/ui/TitleStyles";
import Description from "../../../components/ui/Description";
import PhotoUploadGroup from "../../../components/photoUploadGroup/PhotoUploadGroup"; // ajuste o caminho se necessário

const Photo = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <TitleStyles>Foto</TitleStyles>
      <Description>
        Adicione até 3 fotos: uma de perfil e duas secundárias
      </Description>

      <PhotoUploadGroup />

      <Position>
        <ProgressBar totalSteps={9} currentStep={4} />
        <ButtonGroup
          onBack={() => navigate("/video")}
          onNext={() => navigate("/phrase")}
        />
      </Position>
    </Container>
  );
};

export default Photo;
